import { render } from "./ModalConfirmApi.vue?vue&type=template&id=22226a0d"
import script from "./ModalConfirmApi.vue?vue&type=script&lang=js"
export * from "./ModalConfirmApi.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__